import { MainAction, IMainActionMetadata } from '../types/action-types';

/**
 * Registry for main actions displayed in the header dropdown
 */
export const MAIN_ACTIONS: IMainActionMetadata[] = [
    {
        id: MainAction.COMMON_ACTIONS,
        label: 'Common Actions',
        isComplex: false,
    },
    {
        id: MainAction.ORDER_ELIGIBILITY,
        label: 'Check Order Eligibility',
        isComplex: true,
    },
    {
        id: MainAction.STORE_FEATURES,
        label: 'Manage Store Features',
        isComplex: true,
        isSysAdminOnly: true,
    },
    {
        id: MainAction.REFUND_CALCULATOR,
        label: 'Refund Calculator',
        isComplex: true,
        isSysAdminOnly: false,
    },
    {
        id: MainAction.ADMIN_TRANSLATIONS,
        label: 'Manage Admin Translations',
        isComplex: true,
        isSysAdminOnly: true,
    },
    {
        id: MainAction.CREATE_PLATFORM_STORE,
        label: 'Create Platform Store',
        isComplex: true,
        isSysAdminOnly: true,
    },
    {
        id: MainAction.PROFILES,
        label: 'Profiles',
        isComplex: true,
        isSysAdminOnly: true,
    },
    {
        id: MainAction.EMAIL_VALIDATION,
        label: 'Email Validation',
        isComplex: true,
    },
    {
        id: MainAction.CREATE_ADMINISTRATORS,
        label: 'Create Administrators',
        isComplex: true,
        isSysAdminOnly: true,
    },
    {
        id: MainAction.DUPLICATE_STORE,
        label: 'Duplicate Store',
        isComplex: true,
        isSysAdminOnly: true,
    },
];

/**
 * Get main action metadata by ID
 */
export const getMainAction = (id: MainAction): IMainActionMetadata | undefined => {
    return MAIN_ACTIONS.find(action => action.id === id);
};

/**
 * Get all main actions
 */
export const getAllMainActions = (includeSysAdminOnly: boolean = false): IMainActionMetadata[] => {
    if (includeSysAdminOnly) {
        return MAIN_ACTIONS;
    }
    return MAIN_ACTIONS.filter(action => !action.isSysAdminOnly);
};

